module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class_inside"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fix",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showNote())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf536d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ClassInside.vue
// module id = 1261
// module chunks = 4